export default "__VITE_ASSET__7f647740__"